enum CheckSecretariaStatusEnum {
  ContaCadastrada = 'ContaCadastrada',
  Medico = 'Medico',
  Secretaria = 'Secretaria',
  CpfNaoEncontrado = 'CpfNaoEncontrado',
}

export default CheckSecretariaStatusEnum
